export default "__VITE_ASSET__c20fd8df__"